import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Card, CardHeader, CardBody, Input, Container, Col, Row, Button, Alert, Form, FormGroup, Label } from 'reactstrap';
import { resetPassword } from '../../store/customer/actions'
import validate from './_validate'

function CustomerResetPassword(props) {
    const
        { success, handleSubmit, loading, error } = props

    function onSubmit(values) {
        const
            params = new URLSearchParams(props.location.search),
            token = params.get('token');

        props.resetPassword(token, values.password, values.confirmPassword);
    }

    function renderInputField(field) {
        const
            { meta: { touched, error } } = field,
            hasError = touched && error ? true : false,
            labelClass = field.labelClass ? field.labelClass : 'mt-1';

        return <FormGroup row size='sm'>
            <Col xs='12' >
                <Label className={labelClass} >{field.label}</Label>
            </Col>
            <Col xs="12">
                <Input {...field.input} invalid={hasError} type={field.type} />
            </Col>
        </FormGroup>
    }

    return <Container>
        {
            error && (
                <Row>
                    <Col>
                        <Alert color="danger">
                            {error}
                        </Alert>
                    </Col>
                </Row>
            )
        }
        <Row>
            <Col md='2' lg='3' />
            <div className='mt-5 col-md-8 col-lg-6'>
                <Card>
                    <CardHeader>
                        Reestablecer tu contraseña
                </CardHeader>
                    <CardBody>
                        {!success
                            ? <div>
                                <Form onSubmit={handleSubmit(handleSubmit(onSubmit))} >
                                    <Field
                                        name='password'
                                        label='Nueva Contraseña:'
                                        type='password'
                                        component={renderInputField}
                                    />
                                    <Field
                                        name='confirmPassword'
                                        label='Confirmar Contraseña:'
                                        type='password'
                                        component={renderInputField}
                                    />
                                    <Row>
                                        <Col className='mt-2'>
                                            <Button disabled={loading} type='submit' color='primary' className='mr-2' >
                                                <i className="fa fa-save mr-1" />
                                                Guardar
                                    </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                            : <div>
                                <Row>
                                    <Col>
                                        <Alert color="success">Contraseña restablecida satisfactoriamente.</Alert>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Button color='primary' onClick={() => props.history.push('/login')}>
                                            Aceptar
                            </Button>
                                    </Col>
                                </Row>
                            </div>
                        }
                    </CardBody>
                </Card>
            </div>
            <Col md='2' lg='3' />
        </Row>
    </Container>
}

function mapStateToProps(state) {
    const { success, error, loading } = state.customer.resetPassword;

    return {
        success,
        error,
        loading
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        resetPassword
    }, dispatch)
}

export default reduxForm({
    form: 'CustomerResetPasswordForm',
    touchOnBlur: false,
    validate
})(
    connect(mapStateToProps, mapDispatchToProps)(CustomerResetPassword)
)



// WEBPACK FOOTER //
// ./src/scenes/CustomerResetPassword/CustomerResetPassword.js